import React, { useEffect, useRef, useState } from "react";
import {
	HomeIntroInner,
	HomeIntroMenuBarLeft,
	HomeIntroMenuBarRight,
	HomeIntroMenuBarRoute,
	HomeIntroMenuBarRouteA,
	HomeIntroMenuBarRouteLogin,
	HomeIntroMenuBorderLang,
	HomeIntroWrapper,
	HomeLoginAvatar,
	HomeMenuLoginName,
	HomeMenuLoginOption,
	HomeMenuLoginOptionImg,
	HomeMenuLoginOptionInner,
	HomeMenuLoginOptionLink,
	HomeMenuLoginOptionLogOut,
	HomeMenuLoginSelect,
	HomeMenuLoginWrap,
	HomeMenuLoginWrapWrap,
	HomeMenuIcon,
	HomeRouterLinkActive,
	HomeRouterLinkActiveImg,
} from "../styled/HomeStyles";
import { OptionLanguage } from "./OptionLang";
import DialogLogin from "../../LoginUser/LoginDialog";
import useLoadedUser from "../../../hooks/auth/useLoadedUser";
import DialogCreateOne from "../../LoginUser/CreateOne";
import useLogout from "../../../hooks/auth/useLogout";
import { push } from "@whalelo/audit-client";
import { UserRole } from "../../../../models/User";
import DialogForgot from "../../LoginUser/ForgotPassword";
import { getAdminNavItemByTo, getAdminNavItemsForMenu } from "../../../../config/adminNavigationCatalog";
import MyAccessDialog from "./MyAccessDialog";

export default function HomeIntroMenu() {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [isDialogOpenCreate, setIsDialogOpenCreate] = useState(false);
	const [isDialogOpenForgot, setIsDialogOpenForgot] = useState(false);
	const [dropdownVisible, setDropdownVisible] = useState(false);
	const [isMyAccessOpen, setIsMyAccessOpen] = useState(false);
	const { landingPageLogout } = useLogout();
	const openLogin = () => {
		setIsDialogOpen(true);
	};
	const { user } = useLoadedUser();

	const toggleDropdown = (event?: React.MouseEvent) => {
		event?.stopPropagation();
		setDropdownVisible((prev) => !prev);
	};
	const closeDropdown = () => setDropdownVisible(false);
	const dropdownRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdownVisible(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [dropdownRef]);

	return (
		<HomeIntroWrapper data-track-section="home-intro-menu">
			<HomeIntroInner>
				<HomeIntroMenuBarLeft>
					<HomeRouterLinkActive
						to={"/"}
						data-track="nav-logo-home">
						<HomeRouterLinkActiveImg
							src="./static/img/Logo.png"
							alt="Logo Whalelo"
						/>
					</HomeRouterLinkActive>
				</HomeIntroMenuBarLeft>
				<HomeIntroMenuBarRight>
					{user ? (
						user.role === UserRole.Admin ? (
							<HomeMenuLoginWrapWrap ref={dropdownRef}>
								<HomeMenuLoginWrap onClick={toggleDropdown}>
									<HomeLoginAvatar src={user.avatar || user.urlImage || "./static/img/avatar.jpg"} />
									{/* <HomeMenuLoginName>{user.fullName || user.phone || "Họ tên"}</HomeMenuLoginName> */}
									<i
										className="fa fa-angle-down"
										aria-hidden="true"></i>
								</HomeMenuLoginWrap>
								{dropdownVisible && (
									<HomeMenuLoginSelect onClick={(event) => event.stopPropagation()}>
										<HomeMenuLoginOptionLink
											to="/"
											onClick={closeDropdown}>
											<HomeMenuLoginOption>
												<HomeMenuIcon className="fa fa-th-large" />
												<HomeMenuLoginOptionInner>
													{getAdminNavItemByTo("/")?.label ?? "All tools"}
												</HomeMenuLoginOptionInner>
											</HomeMenuLoginOption>
										</HomeMenuLoginOptionLink>
										{getAdminNavItemsForMenu().map((item) => (
											<HomeMenuLoginOptionLink
												key={item.to}
												to={item.to}
												onClick={closeDropdown}>
												<HomeMenuLoginOption>
													<HomeMenuIcon className={item.icon} />
													<HomeMenuLoginOptionInner>{item.label}</HomeMenuLoginOptionInner>
												</HomeMenuLoginOption>
											</HomeMenuLoginOptionLink>
										))}
										<HomeMenuLoginOption
											onClick={() => {
												closeDropdown();
												setIsMyAccessOpen(true);
											}}
											style={{ cursor: "pointer" }}>
											<HomeMenuIcon className="fa fa-id-badge" />
											<HomeMenuLoginOptionInner>My access</HomeMenuLoginOptionInner>
										</HomeMenuLoginOption>
										<HomeMenuLoginOptionLogOut
											onClick={() => {
												closeDropdown();
												push({
													app: "admin",
													category: "auth",
													action: "auth.logout",
													occurred_at: new Date().toISOString(),
													severity: 1,
													summary: "Admin logout",
													meta: null,
												});
												landingPageLogout();
											}}>
											<HomeMenuIcon
												className="fa fa-sign-out"
												style={{ color: "#ef4444" }}
											/>
											<HomeMenuLoginOptionInner style={{ color: "#ef4444" }}>
												Log out
											</HomeMenuLoginOptionInner>
										</HomeMenuLoginOptionLogOut>
									</HomeMenuLoginSelect>
								)}
							</HomeMenuLoginWrapWrap>
						) : (
							<HomeMenuLoginWrapWrap ref={dropdownRef}>
								<HomeMenuLoginWrap onClick={toggleDropdown}>
									<HomeLoginAvatar src={user.avatar || user.urlImage || "./static/img/avatar.jpg"} />
									{/* <HomeMenuLoginName>{user.fullName || user.phone || "Họ tên"}</HomeMenuLoginName> */}
									<i
										className="fa fa-angle-down"
										aria-hidden="true"></i>
								</HomeMenuLoginWrap>
								{dropdownVisible && (
									<HomeMenuLoginSelect onClick={(event) => event.stopPropagation()}>
										{/* <HomeMenuLoginOption onClick={openSupport}><img src="./static/img/users02.png"/><HomeMenuLoginOptionInner>{TranslateLabels[lang]?.LOGIN_SUPPORT}</HomeMenuLoginOptionInner></HomeMenuLoginOption> */}
										<HomeMenuLoginOptionLink
											to="/my-booking"
											onClick={closeDropdown}>
											<HomeMenuLoginOption>
												<HomeMenuLoginOptionImg src="./static/img/world.png" />
												<HomeMenuLoginOptionInner>My Bookings</HomeMenuLoginOptionInner>
											</HomeMenuLoginOption>
										</HomeMenuLoginOptionLink>
										{/* <HomeMenuLoginOptionLink to="/person-info">
											<HomeMenuLoginOption>
												<HomeMenuLoginOptionImg src="./static/img/user.png" />
												<HomeMenuLoginOptionInner>Account</HomeMenuLoginOptionInner>
											</HomeMenuLoginOption>
										</HomeMenuLoginOptionLink> */}
										<HomeMenuLoginOptionLogOut
											onClick={() => {
												closeDropdown();
												push({
													app: "admin",
													category: "auth",
													action: "auth.logout",
													occurred_at: new Date().toISOString(),
													severity: 1,
													summary: "User logout",
													meta: null,
												});
												landingPageLogout();
											}}>
											<HomeMenuLoginOptionImg src="./static/img/logout.png" />
											<HomeMenuLoginOptionInner>Log out</HomeMenuLoginOptionInner>
										</HomeMenuLoginOptionLogOut>
									</HomeMenuLoginSelect>
								)}
							</HomeMenuLoginWrapWrap>
						)
					) : (
						<HomeIntroMenuBarRouteLogin onClick={openLogin}>
							<HomeIntroMenuBarRoute>Login</HomeIntroMenuBarRoute>
						</HomeIntroMenuBarRouteLogin>
					)}

					{/* <HomeIntroMenuBorderLang>
						<OptionLanguage />
					</HomeIntroMenuBorderLang> */}
				</HomeIntroMenuBarRight>
			</HomeIntroInner>
			<DialogLogin
				openDialog={isDialogOpen}
				setOpenDialog={setIsDialogOpen}
				setIsDialogOpenCreate={setIsDialogOpenCreate}
				setIsDialogOpenForgot={setIsDialogOpenForgot}
			/>
			<DialogCreateOne
				openDialog={isDialogOpenCreate}
				setOpenDialog={setIsDialogOpenCreate}
				setOpenDialogLogin={setIsDialogOpen}
			/>
			<DialogForgot
				openDialog={isDialogOpenForgot}
				setOpenDialog={setIsDialogOpenForgot}
				setOpenDialogLogin={setIsDialogOpen}
			/>
			<MyAccessDialog
				open={isMyAccessOpen}
				onClose={() => setIsMyAccessOpen(false)}
			/>
		</HomeIntroWrapper>
	);
}
